import { render } from "./ChartCard.vue?vue&type=template&id=54b5e99c"
import script from "./ChartCard.vue?vue&type=script&lang=js"
export * from "./ChartCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__